module.exports = __webpack_public_path__ + "static/media/manga.29b5a105.png";